// @flow

export default function formatDate(locale: string) {
  const dateTimeFormat = new Intl.DateTimeFormat(locale, {
    day   : "numeric",
    month : "long",
    year  : "numeric",
  });

  return (date: string) =>
    typeof date === "string" ?
      dateTimeFormat.format(new Date(date)) :
    typeof date === "object" ?
      dateTimeFormat.format(date) :
      null;
}

export function addYears(date, years: 0) {
  if (!date) {
    return;
  }

  const newDate = new Date(typeof date === "string" ? date : date.getTime());
  return new Date(newDate.setFullYear(newDate.getFullYear() + years));
}
